var _path, _path2, _path3, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOptimizationEngine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,29.25a14.75046,14.75046,0,1,0,10.42969,4.32031A14.65009,14.65009,0,0,0,40,29.25Zm9.36914,24.11914A13.24988,13.24988,0,1,1,53.25,44,13.163,13.163,0,0,1,49.36914,53.36914Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.87988,36.05957l-1.14306,1.14124A8.89907,8.89907,0,0,0,33.70508,50.29492l1.06054-1.06054a7.40258,7.40258,0,0,1,9.90967-10.97376L41.30786,41.6225A2.70591,2.70591,0,0,0,39.9541,41.25a2.73755,2.73755,0,1,0,2.73828,2.7373,2.70317,2.70317,0,0,0-.33838-1.29058l5.58643-5.5766ZM39.9541,45.2251a1.23755,1.23755,0,1,1,1.23828-1.2378A1.23865,1.23865,0,0,1,39.9541,45.2251Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,24V64a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V16a.7502.7502,0,0,0-.75-.75H10a.7502.7502,0,0,0-.75.75Zm1.5-7.25h58.5v6.5H10.75Zm0,8h58.5v38.5H10.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 20,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 20,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptimizationEngine);
export default __webpack_public_path__ + "static/media/icon_optimization_engine.9cfef53e7e7ecb59043b521a82940ef3.svg";
export { ForwardRef as ReactComponent };